import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=6a4c65de&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c65de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a4c65de')) {
      api.createRecord('6a4c65de', component.options)
    } else {
      api.reload('6a4c65de', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=6a4c65de&scoped=true&", function () {
      api.rerender('6a4c65de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2k6rphBAVPYny/JS/comp/Accordion.vue"
export default component.exports